import React from 'react'
import './item-preview.style.scss'
import CustomButton from '../custom-button/custom-button.component'
import {connect} from 'react-redux'
import { addItem } from '../../redux/cart/cart.action'


const ItemPreview = ({item, addItem}) => {
  const {name, price, imageUrl} = item
  return (
    <div className='item-preview'>
      <img className='img' src={imageUrl} alt='1'/>
  
      <div className='second'>
        <h6>{name}</h6>
        <h6>{`$${price}`}</h6> 
      </div>
      
      <div className='bot'> 
        <CustomButton onClick={() => addItem(item)}
        inverted >add to cart</CustomButton>
      </div>
      
    </div>
  )}

const mapDispatchToProps = (dispatch) => ({
  addItem: item => dispatch(addItem(item))  
})

export default connect(null, mapDispatchToProps)(ItemPreview)